import { safelyWriteToLocalStorage } from '../utils/storageUtils';

export class Cookie {
    constructor(cname) {
        this.name = cname;
        // Inicializuojame failsafe cookie alternatyvą
        this.localStorageKey = `cookie_${cname}`;
    }

    getCookie() {
        // Pirmiausia bandom gauti iš cookie
        let name = this.name + "=";
        let decodedCookie = "";
        
        try {
            decodedCookie = decodeURIComponent(document.cookie);
        } catch (e) {
            // Jei decodeURIComponent nepavyksta
            decodedCookie = document.cookie;
        }
        
        let ca = decodedCookie.split('; ');
        let returnValue = undefined;

        ca.forEach((cookie) => {
            if (cookie.indexOf(name) === 0) {
                returnValue = cookie.substring(name.length);
            }
        });

        // Jei cookie nerastas, bandom iš localStorage kaip alternatyvą
        if (!returnValue) {
            try {
                returnValue = localStorage.getItem(this.localStorageKey);
            } catch (e) {
                // Tyliai praleisti, jei localStorage nepasiekiamas
            }
        }

        return returnValue;
    }
    setCookie(token) {
        // Nustatyti cookie
        try {
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + 30); // 30 dienų
            document.cookie = this.name + "=" + token + "; expires=" + expirationDate.toUTCString() + "; path=/; SameSite=Strict; Secure;";
            
            // Taip pat išsaugoti localStorage kaip atsarginę kopiją
            safelyWriteToLocalStorage(this.localStorageKey, token);
        } catch (e) {
            // Tyliai praleisti klaidą, bent jau bandome išsaugoti localStorage
            try {
                safelyWriteToLocalStorage(this.localStorageKey, token);
            } catch (innerError) {
                // Jei ir čia nepavyko, nieko negalime padaryti
            }
        }
    }
    removeCookie() {
        // Išvalyti cookie
        document.cookie = this.name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure;";
        
        // Išvalyti ir iš localStorage
        try {
            localStorage.removeItem(this.localStorageKey);
        } catch (e) {
            // Tyliai praleisti klaidą
        }
    }
    
    // Alias deleteCookie funkcijai, kad būtų suderinama
    deleteCookie() {
        this.removeCookie();
    }
}
